const gameData = [
  { unixtime: 1772370000, round: 0 },
  { unixtime: 1772974799, round: 0 },

  { unixtime: 1772974800, round: 1 },
  { unixtime: 1773579599, round: 1 },

  { unixtime: 1773579600, round: 2 },
  { unixtime: 1774184399, round: 2 },

  { unixtime: 1774184400, round: 3 },
  { unixtime: 1774789199, round: 3 },

  { unixtime: 1774789200, round: 4 },
  { unixtime: 1775397599, round: 4 },

  { unixtime: 1775397600, round: 5 },
  { unixtime: 1776002399, round: 5 },

  { unixtime: 1776002400, round: 6 },
  { unixtime: 1776607199, round: 6 },

  { unixtime: 1776607200, round: 7 },
  { unixtime: 1777211999, round: 7 },

  { unixtime: 1777212000, round: 8 },
  { unixtime: 1777816799, round: 8 },

  { unixtime: 1777816800, round: 9 },
  { unixtime: 1778421599, round: 9 },

  { unixtime: 1778421600, round: 10 },
  { unixtime: 1779026399, round: 10 },

  { unixtime: 1779026400, round: 11 },
  { unixtime: 1779631199, round: 11 },

  { unixtime: 1779631200, round: 12 },
  { unixtime: 1780235999, round: 12 },

  { unixtime: 1780236000, round: 13 },
  { unixtime: 1780840799, round: 13 },

  { unixtime: 1780840800, round: 14 },
  { unixtime: 1781445599, round: 14 },

  { unixtime: 1781445600, round: 15 },
  { unixtime: 1782050399, round: 15 },

  { unixtime: 1782050400, round: 16 },
  { unixtime: 1782655199, round: 16 },

  { unixtime: 1782655200, round: 17 },
  { unixtime: 1783259999, round: 17 },

  { unixtime: 1783260000, round: 18 },
  { unixtime: 1783864799, round: 18 },

  { unixtime: 1783864800, round: 19 },
  { unixtime: 1784469599, round: 19 },

  { unixtime: 1784469600, round: 20 },
  { unixtime: 1785074399, round: 20 },

  { unixtime: 1785074400, round: 21 },
  { unixtime: 1785679199, round: 21 },

  { unixtime: 1785679200, round: 22 },
  { unixtime: 1786283999, round: 22 },

  { unixtime: 1786284000, round: 23 },
  { unixtime: 1786888799, round: 23 },

  { unixtime: 1786888800, round: 24 },
  { unixtime: 1787493599, round: 24 },
];

export const getCurrentRound = (unixtime) => {
  let currentRound = 0;
  for (const game of gameData) {
    if (unixtime >= game.unixtime) {
      currentRound = game.round;
    } else {
      break;
    }
  }
  return currentRound;
};
